import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { RankType } from '@/api/workspaces-api'
import About from '@/components/billboard/top100/content/about'
import Billboard from '@/components/billboard/top100/content/billboard'
import TopList from '@/components/billboard/top100/content/top-list'
import {
  AnalyzeRankingItem,
  RankingPlatformType,
} from '@/types/schema/k6/analyze-api'

interface ContentProps {
  aboutList: string[]
  analyzeRankingList: AnalyzeRankingItem[]
  platform: RankingPlatformType
  lastUpdatedAt: string | null
  rankType: RankType
}

const Content: FunctionComponent<ContentProps> = ({
  analyzeRankingList,
  platform,
  aboutList,
  lastUpdatedAt,
  rankType,
}) => {
  return (
    <Background>
      <Wrapper>
        <About aboutList={aboutList} lastUpdatedAt={lastUpdatedAt} />
        {analyzeRankingList.length > 0 && (
          <TopList
            platform={platform}
            top3List={[
              analyzeRankingList[0],
              analyzeRankingList[1],
              analyzeRankingList[2],
            ]}
          />
        )}
        <Billboard
          analyzeRankingList={analyzeRankingList.slice(3)}
          lastUpdatedAt={lastUpdatedAt}
          platform={platform}
          rankType={rankType}
        />
      </Wrapper>
    </Background>
  )
}

const Wrapper = styled.div`
  max-width: 1140px;
  margin: 0 auto;
  padding: 40px 0 128px;

  @media (max-width: 768px) {
    padding: 24px 16px 112px;
  }
`
const Background = styled.div`
  background-color: ${({ theme }): string => theme.colors.background.grey};

  ${About} {
    margin-bottom: 40px;
  }

  ${TopList} {
    margin-bottom: 40px;
  }
`

export default Content
